import { ThumbDownIcon } from './ThumbDownIcon';

/**
 * author: Google
 * id 83D606E3-69A1-4583-854D-5C44477D038D
 * name thumb-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumb-down.svg
 * tags
 */
export const ThumbsDownIcon = ThumbDownIcon;
export default ThumbsDownIcon